import { loadStripe } from "@stripe/stripe-js";
// @ts-ignore
const stripePublicKey = window.STRIPE_PUBLIC_KEY;
const stripePromise = loadStripe(stripePublicKey);
export default {
    stripePromise
};
